var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 168,
    viewBox: "0 0 158 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.213 33.3722L122.559 55.0136C118.087 49.0482 112.28 44.2101 105.602 40.8861C98.9244 37.5621 91.5605 35.8442 84.0993 35.8698C57.5271 35.8698 35.9128 57.4581 35.9128 83.9984C35.9128 110.539 57.5271 132.12 84.0993 132.12L116.943 105.514V168H84.0993C67.4657 168 51.2057 163.074 37.3755 153.844C23.5453 144.614 12.766 131.494 6.4008 116.145C0.0356281 100.796 -1.62954 83.9069 1.61586 67.6126C4.86127 51.3184 12.8715 36.3513 24.6335 24.6041C32.4242 16.7793 41.6915 10.5758 51.8988 6.35247C62.1062 2.12918 73.0508 -0.0299536 84.0993 6.46122e-05C97.1095 -0.00874104 109.944 3.00117 121.591 8.79248C133.237 14.5838 143.378 22.9982 151.213 33.3722V33.3722ZM125.156 98.2234V168H158V71.62L125.156 98.2234Z",
    fill: "url(#paint0_linear_1213_3944)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1213_3944",
    x1: -0.0000354225,
    y1: 83.9984,
    x2: 158,
    y2: 83.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AE1B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FCDEE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.c70b3052dd82d4fd2342bd0803abb21f.svg";
export { ForwardRef as ReactComponent };